<template>
    <div>
        <div class="pagetitle">
            <h1>FAQ'S</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">FAQ'S</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahFaq">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah FAQ
            </a>
        </div> <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">FAQ'S</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" v-model="searchQuery" @change="fetchFaqs" placeholder="Search by Question ....... " class="form-control mb-3">
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select id="pageSize" v-model="pageSize" @change="fetchFaqs" class="form-select">
                                    <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>No</th>
                                        <th>Question</th>
                                        <th>Answer</th>
                                        <th>Bahasa</th>
                                        <th>Status</th> 
                                        <th style="text-align:center">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(faq, index) in filteredFaqList" :key="faq.id">
                                        <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                        <td>{{ faq.question }}</td>
                                        <td>{{ faq.answer }}</td>
                                        <td>{{ faq.language == 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English' }}</td>
                                        <td>
                                            <span v-if="faq.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align:center">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', faq.id)">
                                            <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteFaq(faq.id)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', faq.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchFaqs">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahFaq" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">FAQ Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addFaq">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="faq.created_by" readonly>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="nama" placeholder="nama" v-model="faq.created_by_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Pertanyaan" v-model="faq.question">
                                    <label for="floatingName">Question</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="jawaban" placeholder="Jawaban" v-model="faq.answer">
                                    <label for="jawaban">Answer</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="faq.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <!-- <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="faq.target">
                                        <option value="faq-content-1">1</option>
                                        <option value="faq-content-2">2</option>
                                        <option value="faq-content-3">3</option>
                                    </select>
                                    <label for="status">Target</label>
                                </div>
                            </div> -->
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="faq.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailFaqModal" class="modal fade" id="detailFaq" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailFaqModalLabel">Detail Faq</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="question">Question</label>
                                        <input type="text" class="form-control" id="question" placeholder="Pertanyaan" v-model="faq.question" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="answer">Answer</label>
                                        <input type="text" class="form-control" id="answer" placeholder="Answer" v-model="faq.answer" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="faq.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="target">Target</label>
                                        <input type="text" class="form-control" id="target" placeholder="Target" v-model="faq.target" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" placeholder="Bahasa" :value="faq.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="faq.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editFaq" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editFaqModalLabel">Edit Faq</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="row g-3" @submit.prevent="updateFaq">
                    <div class="col-md-6">
                        <div class="form-floating">
                        <input type="text" class="form-control" id="updated_by" placeholder="ID" v-model="selectedFaq.updated_by" readonly/>
                        <label for="updated_by">ID User</label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-floating">
                        <input type="text" class="form-control" id="updated_by_name" placeholder="Nama" v-model="selectedFaq.updated_by_name" readonly/>
                        <label for="updated_by_name">Nama User</label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-floating">
                        <input type="text" class="form-control" id="floatingName" placeholder="ID" v-model="faq.id" readonly/>
                        <label for="floatingName">ID FAQ</label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-floating">
                        <input type="text" class="form-control" id="floatingName" placeholder="question" v-model="faq.question"/>
                        <label for="floatingName">Pertanyaan</label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-floating">
                        <input type="text" class="form-control" id="floatingName" placeholder="question" v-model="faq.answer"/>
                        <label for="floatingName">Answer</label>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-floating">
                            <select class="form-select" name="language" id="status" v-model="faq.language">
                                <option value="id">🇮🇩 Indonesia</option>
                                <option value="en">🇬🇧 English</option>
                            </select>
                            <label for="language">Bahasa</label>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 mb-3">
                        <div class="form-floating">
                            <select class="form-select" name="status" id="status" v-model="faq.target">
                                <option value="faq-content-1">1</option>
                                <option value="faq-content-2">2</option>
                                <option value="faq-content-3">3</option>
                            </select>
                            <label for="status">Target</label>
                        </div>
                    </div> -->
                    <div class="col-md-12 mb-3">
                        <div class="form-floating">
                        <select class="form-select" name="status" id="status" v-model="faq.status">
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                        <label for="is_active">Status</label>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                    </form>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import faqjs from './jsFaq/faq';
export default faqjs;
</script>